import React, { useContext } from 'react';
import AFComponent from '../../../components/AFComponent';
import { GlobalContext } from '../../../storage/contexts/GlobalContext';
const AssistenciaFinanceiraInterna : React.FC<{}> = () : React.ReactElement =>{
    
    return (
        <AFComponent userData={useContext(GlobalContext).globalContext.PreUser}/>
    )
}
export default AssistenciaFinanceiraInterna;